import { Box, Flex, Text } from "@chakra-ui/layout";
import { Container } from "./styles";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import moment from "moment";

interface HistoricoSolicitacaoLogsProps {
  data: {
    createdAt: string;
    status: { id: string; nome: string };
    motivo: string;
    pessoa: {
      id: string;
      nome: string;
    };
  };
}

function HistoricoSolicitacaoLogs({ data }: HistoricoSolicitacaoLogsProps) {
  return (
    <Container>
      <Flex mb={"8px"}>
        <Box>
          <Text
            fontSize="16px"
            color={"#8291A9"}
            fontWeight={"500"}
            fontStyle={"italic"}
            mr={"32px"}
          >
            {moment(data.createdAt).format("DD/MM/YYYY HH:mm")}
          </Text>
        </Box>

        <PrimaryButton className={"contato-btn"} onClick={() => {}}>
          <Text
            fontSize="12px"
            color={"#C4C4C4"}
            fontWeight={"500"}
            fontStyle={"italic"}
          >
            {data.status.nome}
          </Text>
        </PrimaryButton>
      </Flex>
      <Box fontSize={"12px"} mb={"8px"}>
        <Text m={0} color={"#8291A9"}>
          MOTIVO:
        </Text>
        <Text m={0}>{data.motivo}</Text>
      </Box>

      <Box fontSize={"12px"} mb={"8px"}>
        <Text m={0} color={"#8291A9"}>
          RESPONSÁVEL:
        </Text>
        <Text m={0}>{data.pessoa.nome}</Text>
      </Box>
    </Container>
  );
}

export default HistoricoSolicitacaoLogs;
